// pages/admin/AdminLogin.js — Conecta Lagoa
// Login do painel administrativo (staff interno). Sessão própria, separada
// da AuthContext de candidato/empresa (localStorage admin_token/admin_user)
// — de propósito, pra não colidir com uma sessão pública já aberta no
// mesmo navegador.
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'https://conectalagoa.onrender.com/api';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, senha }),
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        throw new Error(data.message || 'E-mail ou senha incorretos');
      }
      localStorage.setItem('admin_token', data.token);
      localStorage.setItem('admin_user', JSON.stringify(data.user));
      navigate('/admin', { replace: true });
    } catch (err) {
      setErro(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f1629', fontFamily: "'DM Sans', system-ui, sans-serif" }}>
      <form onSubmit={handleSubmit} style={{ width: 360, maxWidth: '90vw', background: '#161d33', border: '1px solid #232b47', borderRadius: 16, padding: 32 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#e07b00', letterSpacing: '0.05em', textTransform: 'uppercase', marginBottom: 6 }}>
          Conecta Lagoa
        </div>
        <h1 style={{ fontSize: 20, fontWeight: 700, color: 'white', margin: '0 0 24px' }}>Painel administrativo</h1>

        {erro && (
          <div style={{ background: '#3a1a1a', border: '1px solid #7a2e2e', color: '#f0a0a0', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: 16 }}>
            {erro}
          </div>
        )}

        <label style={{ display: 'block', fontSize: 12, color: '#9099b8', marginBottom: 6 }}>E-mail</label>
        <input
          type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="admin@conectalagoa.com.br"
          style={{ width: '100%', padding: '11px 14px', borderRadius: 8, border: '1px solid #2a3255', background: '#0f1629', color: 'white', fontSize: 14, marginBottom: 16, outline: 'none', boxSizing: 'border-box' }}
        />

        <label style={{ display: 'block', fontSize: 12, color: '#9099b8', marginBottom: 6 }}>Senha</label>
        <input
          type="password" required value={senha} onChange={(e) => setSenha(e.target.value)}
          placeholder="••••••••"
          style={{ width: '100%', padding: '11px 14px', borderRadius: 8, border: '1px solid #2a3255', background: '#0f1629', color: 'white', fontSize: 14, marginBottom: 24, outline: 'none', boxSizing: 'border-box' }}
        />

        <button
          type="submit" disabled={loading}
          style={{ width: '100%', padding: '12px', borderRadius: 8, border: 'none', background: loading ? '#4a5578' : '#1a3a8f', color: 'white', fontSize: 14, fontWeight: 700, cursor: loading ? 'default' : 'pointer' }}
        >
          {loading ? 'Entrando...' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
